import { createApp } from 'vue'
import store from './store'
import axios from './axios'
import router from  './router'
import VueAxios from 'vue-axios'
import App from './App.vue'
import './style/app.scss'
import ElementPlus from 'element-plus'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'


const app=createApp(App)
app.directive('preventReClick', {  
  mounted(el, binding) {  
    el.addEventListener('click', () => {  
      if (!el.disabled) {  
        el.disabled = true;  
        el.style.pointerEvents = 'none'; // Vue 3 中使用 pointerEvents 而不是 cursor  
        setTimeout(() => {  
          el.disabled = false;  
          el.style.pointerEvents = 'auto';  
        }, binding.value || 1000);  
      }  
    });  
  }  
});  
app.use(store);
app.use(router);
app.use(VueAxios,axios);
app.use(ElementPlus,{ locale });
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.mount('#app');
